import {
    Input,
    Row,
    Col,
    Divider,
    Space,
    Checkbox,
} from "antd";
import React, { useState, useEffect } from "react";
import "./carform.scss";

const Equipments = (props) => {

    const {
        form, equipments, setForm, isEdit
    } = props;

    const handleFieldChange = (name, e, label, type) => {
        setForm({
            ...form, equipments: {
                ...equipments, [name]: {label: label, value: e.target.value, type: type}
            }
        });
    };

    const onCheckboxChange = (name, e, label, type) => {
        setForm({
            ...form, equipments: {
                ...equipments, [name]: {label: label, value: e.target.checked, type: type}
            }
        });
    };

    return (
        <div>
            <div className="sub-header-title">
                <p className="header">COMFORT</p>
            </div>

            <Row>
                <Col span={8}>
                    <div className="form-fields">
                    <Checkbox
                        valuePropName="checked"
                        checked={equipments?.airConditioning?.value}
                        onChange={(e) => onCheckboxChange("airConditioning", e, 'Air-conditioning', 'comfort')}
                    >
                        Air-conditioning
                    </Checkbox>
                    </div>
                </Col>
                <Col span={8}>
                    <div className="form-fields">
                    <Checkbox
                        valuePropName="checked"
                        checked={equipments?.interiorLighting?.value}
                        onChange={(e) => onCheckboxChange("interiorLighting", e, 'Interior lighting', 'comfort',)}
                    >
                        Interior lighting
                    </Checkbox>
                    </div>
                </Col>
                <Col span={8}>
                    <div className="form-fields">
                    <Checkbox
                        valuePropName="checked"
                        checked={equipments?.cupholders?.value}
                        onChange={(e) => onCheckboxChange("cupholders", e, 'Cupholders', 'comfort')}
                    >
                        Cupholders
                    </Checkbox>
                    </div>
                </Col>
                <Col span={8}>
                    <div className="form-fields">
                    <Checkbox
                        valuePropName="checked"
                        checked={equipments?.powerSteering?.value}
                        onChange={(e) => onCheckboxChange("powerSteering", e, 'Power Steering', 'comfort')}
                    >
                        Power Steering
                    </Checkbox>
                    </div>
                </Col>
                <Col span={8}>
                    <div className="form-fields">
                    <Checkbox
                        valuePropName="checked"
                        checked={equipments?.powerDriverSeat?.value}
                        onChange={(e) => onCheckboxChange("powerDriverSeat", e, 'Power driver seat', 'comfort')}
                    >
                        Power driver seat
                    </Checkbox>
                    </div>
                </Col>
                <Col span={8}>
                    <div className="form-fields">
                    <Checkbox
                        valuePropName="checked"
                        checked={equipments?.powerPasengerSeat?.value}
                        onChange={(e) => onCheckboxChange("powerPasengerSeat", e, 'Power passenger seat', 'comfort')}
                    >
                        Power passenger seat
                    </Checkbox>
                    </div>
                </Col>
            </Row>
            <Row>
                <Col span={24}>
                    <div className="form-fields">
                    <p className="form-field-label">Other Comfort</p>
                    <Input.TextArea
                        rows={3}
                        value={equipments?.comfortOther?.value}
                        onChange={(e) => handleFieldChange("comfortOther", e, 'Other Comfort', 'comfort')}
                    />
                    </div>
                </Col>
            </Row>


            <Divider />

            <div className="sub-header-title">
                <p className="header">CONVENIENCE</p>
            </div>


            <Row>
                <Col span={8}>
                    <div className="form-fields">
                    <Checkbox
                        valuePropName="checked"
                        checked={equipments?.cruiseControl?.value}
                        onChange={(e) => onCheckboxChange("cruiseControl", e, 'Cruise control', 'convenience')}
                    >
                        Cruise control
                    </Checkbox>
                    </div>
                </Col>
                <Col span={8}>
                    <div className="form-fields">
                    <Checkbox
                        valuePropName="checked"
                        checked={equipments?.engineStart?.value}
                        onChange={(e) => onCheckboxChange("engineStart", e, 'Engine start', 'convenience')}
                    >
                        Engine start
                    </Checkbox>
                    </div>
                </Col>
                <Col span={8}>
                    <div className="form-fields">
                    <Checkbox
                        valuePropName="checked"
                        checked={equipments?.parkingSensor?.value}
                        onChange={(e) => onCheckboxChange("parkingSensor", e, 'Parking sensor', 'convenience')}
                    >
                        Parking sensor
                    </Checkbox>
                    </div>
                </Col>
                <Col span={8}>
                    <div className="form-fields">
                    <Checkbox
                        valuePropName="checked"
                        checked={equipments?.powerDoor?.value}
                        onChange={(e) => onCheckboxChange("powerDoor", e, 'Power door', 'convenience')}
                    >
                        Power door
                    </Checkbox>
                    </div>
                </Col>
                <Col span={8}>
                    <div className="form-fields">
                    <Checkbox
                        valuePropName="checked"
                        checked={equipments?.powerWindows?.value}
                        onChange={(e) => onCheckboxChange("powerWindows", e, 'Power windows', 'convenience')}
                    >
                        Power windows
                    </Checkbox>
                    </div>
                </Col>
                <Col span={8}>
                    <div className="form-fields">
                    <Checkbox
                        valuePropName="checked"
                        checked={equipments?.reverseCamera?.value}
                        onChange={(e) => onCheckboxChange("reverseCamera", e, 'Reverse camera', 'convenience')}
                    >
                        Reverse camera
                    </Checkbox>
                    </div>
                </Col>
                <Col span={8}>
                    <div className="form-fields">
                    <Checkbox
                        valuePropName="checked"
                        checked={equipments?.powerSideMirror?.value}
                        onChange={(e) => onCheckboxChange("powerSideMirror", e, 'Power side mirror', 'convenience')}
                    >
                        Power side mirror
                    </Checkbox>
                    </div>
                </Col>
                <Col span={8}>
                    <div className="form-fields">
                    <Checkbox
                        valuePropName="checked"
                        checked={equipments?.remoteLocking?.value}
                        onChange={(e) => onCheckboxChange("remoteLocking", e, 'Remote locking', 'convenience')}
                    >
                        Remote locking
                    </Checkbox>
                    </div>
                </Col>
                <Col span={8}>
                    <div className="form-fields">
                    <Checkbox
                        valuePropName="checked"
                        checked={equipments?.splitFoldReadSeat?.value}
                        onChange={(e) => onCheckboxChange("splitFoldReadSeat", e, 'Split fold read seat', 'convenience')}
                    >
                        Split fold read seat
                    </Checkbox>
                    </div>
                </Col>
                <Col span={8}>
                    <div className="form-fields">
                    <Checkbox
                        valuePropName="checked"
                        checked={equipments?.steeringTilt?.value}
                        onChange={(e) => onCheckboxChange("steeringTilt", e, 'Steering tilt', 'convenience')}
                    >
                        Steering tilt
                    </Checkbox>
                    </div>
                </Col>
                <Col span={8}>
                    <div className="form-fields">
                    <Checkbox
                        valuePropName="checked"
                        checked={equipments?.steeringWheelControls?.value}
                        onChange={(e) => onCheckboxChange("steeringWheelControls", e, 'Steering wheel controls', 'convenience')}
                    >
                        Steering wheel controls
                    </Checkbox>
                    </div>
                </Col>
            </Row>
            <Row>
                <Col span={24}>
                    <div className="form-fields">
                    <p className="form-field-label">Other Convenience</p>
                    <Input.TextArea
                        rows={3}
                        value={equipments?.convenienceOther?.value}
                        onChange={(e) => handleFieldChange("convenienceOther", e, 'Other Convenience', 'convenience')}
                    />
                    </div>
                </Col>
            </Row>


            <Divider />

            <div className="sub-header-title">
                <p className="header">ENTERTAINMENT</p>
            </div>


            <Row>
                <Col span={8}>
                    <div className="form-fields">
                    <Checkbox
                        valuePropName="checked"
                        checked={equipments?.entertainmentAux?.value}
                        onChange={(e) => onCheckboxChange("entertainmentAux", e, 'Aux', 'entertainment')}
                    >
                        Aux
                    </Checkbox>
                    </div>
                </Col>
                <Col span={8}>
                    <div className="form-fields">
                    <Checkbox
                        valuePropName="checked"
                        checked={equipments?.entertainmentCd?.value}
                        onChange={(e) => onCheckboxChange("entertainmentCd", e, 'CD', 'entertainment')}
                    >
                        CD
                    </Checkbox>
                    </div>
                </Col>
                <Col span={8}>
                    <div className="form-fields">
                    <Checkbox
                        valuePropName="checked"
                        checked={equipments?.entertainmentIpod?.value}
                        onChange={(e) => onCheckboxChange("entertainmentIpod", e, 'iPod', 'entertainment')}
                    >
                        iPod
                    </Checkbox>
                    </div>
                </Col>
                <Col span={8}>
                    <div className="form-fields">
                    <Checkbox
                        valuePropName="checked"
                        checked={equipments?.entertainmentRadio?.value}
                        onChange={(e) => onCheckboxChange("entertainmentRadio", e, 'Radio', 'entertainment')}
                    >
                        Radio
                    </Checkbox>
                    </div>
                </Col>
                <Col span={8}>
                    <div className="form-fields">
                    <Checkbox
                        valuePropName="checked"
                        checked={equipments?.entertainmentMultiFunctionScreen?.value}
                        onChange={(e) => onCheckboxChange("entertainmentMultiFunctionScreen", e, 'Multi function screen', 'entertainment')}
                    >
                        Multi function screen
                    </Checkbox>
                    </div>
                </Col>
                <Col span={8}>
                    <div className="form-fields">
                    <Checkbox
                        valuePropName="checked"
                        checked={equipments?.entertainmentSpeaker?.value}
                        onChange={(e) => onCheckboxChange("entertainmentSpeaker", e, 'Speaker', 'entertainment')}
                    >
                        Speaker
                    </Checkbox>
                    </div>
                </Col>
                <Col span={8}>
                    <div className="form-fields">
                    <Checkbox
                        valuePropName="checked"
                        checked={equipments?.entertainmentUsb?.value}
                        onChange={(e) => onCheckboxChange("entertainmentUsb", e, 'USB', 'entertainment')}
                    >
                        USB
                    </Checkbox>
                    </div>
                </Col>
            </Row>
            <Row>
                <Col span={24}>
                    <div className="form-fields">
                    <p className="form-field-label">Other Entertainment</p>
                    <Input.TextArea
                        rows={3}
                        value={equipments?.entertainmentOther?.value}
                        onChange={(e) => handleFieldChange("entertainmentOther", e, 'Other Entertainment', 'entertainment')}
                    />
                    </div>
                </Col>
            </Row>

            <Divider />

            <div className="sub-header-title">
                <p className="header">LIGHTING</p>
            </div>


            <Row>
                <Col span={8}>
                    <div className="form-fields">
                    <Checkbox
                        valuePropName="checked"
                        checked={equipments?.brakeLights?.value}
                        onChange={(e) => onCheckboxChange("brakeLights", e, 'Brake lights', 'lighting')}
                    >
                        Brake lights
                    </Checkbox>
                    </div>
                </Col>
                <Col span={8}>
                    <div className="form-fields">
                    <Checkbox
                        valuePropName="checked"
                        checked={equipments?.frontFoglamps?.value}
                        onChange={(e) => onCheckboxChange("frontFoglamps", e, 'Front foglamps', 'lighting')}
                    >
                        Front foglamps
                    </Checkbox>
                    </div>
                </Col>
                <Col span={8}>
                    <div className="form-fields">
                    <Checkbox
                        valuePropName="checked"
                        checked={equipments?.headlamps?.value}
                        onChange={(e) => onCheckboxChange("headlamps", e, 'Headlamps', 'lighting')}
                    >
                        Headlamps
                    </Checkbox>
                    </div>
                </Col>
                <Col span={8}>
                    <div className="form-fields">
                    <Checkbox
                        valuePropName="checked"
                        checked={equipments?.rearFoglamps?.value}
                        onChange={(e) => onCheckboxChange("rearFoglamps", e, 'Rear foglamps', 'lighting')}
                    >
                        Rear foglamps
                    </Checkbox>
                    </div>
                </Col>
                <Col span={8}>
                    <div className="form-fields">
                    <Checkbox
                        valuePropName="checked"
                        checked={equipments?.sideMirrorTurningIndicators?.value}
                        onChange={(e) => onCheckboxChange("sideMirrorTurningIndicators", e, 'Side mirror turning indicators', 'lighting')}
                    >
                        Side mirror turning indicators
                    </Checkbox>
                    </div>
                </Col>
                <Col span={8}>
                    <div className="form-fields">
                    <Checkbox
                        valuePropName="checked"
                        checked={equipments?.ledDaytimeRunningLights?.value}
                        onChange={(e) => onCheckboxChange("ledDaytimeRunningLights", e, 'LED Daytime running lights', 'lighting')}
                    >
                        LED Daytime running lights
                    </Checkbox>
                    </div>
                </Col>
                <Col span={8}>
                    <div className="form-fields">
                    <Checkbox
                        valuePropName="checked"
                        checked={equipments?.taillamps?.value}
                        onChange={(e) => onCheckboxChange("taillamps", e, 'Taillamps', 'lighting')}
                    >
                        Taillamps
                    </Checkbox>
                    </div>
                </Col>
            </Row>
            <Row>
                <Col span={24}>
                    <div className="form-fields">
                    <p className="form-field-label">Other Lighting</p>
                    <Input.TextArea
                        rows={3}
                        value={equipments?.lightingOther?.value}
                        onChange={(e) => handleFieldChange("lightingOther", e, 'Other Lighting', 'lighting')}
                    />
                    </div>
                </Col>
            </Row>


            <Divider />

            <div className="sub-header-title">
                <p className="header">SAFETY</p>
            </div>

            <Row>
                <Col span={8}>
                    <div className="form-fields">
                    <Checkbox
                        valuePropName="checked"
                        checked={equipments?.absEbd?.value}
                        onChange={(e) => onCheckboxChange("absEbd", e, 'ABS/EBD', 'safety')}
                    >
                        ABS/EBD
                    </Checkbox>
                    </div>
                </Col>
                <Col span={8}>
                    <div className="form-fields">
                    <Checkbox
                        valuePropName="checked"
                        checked={equipments?.alarm?.value}
                        onChange={(e) => onCheckboxChange("alarm", e, 'Alarm', 'safety')}
                    >
                        Alarm
                    </Checkbox>
                    </div>
                </Col>
                <Col span={8}>
                    <div className="form-fields">
                    <Checkbox
                        valuePropName="checked"
                        checked={equipments?.childSafetyLock?.value}
                        onChange={(e) => onCheckboxChange("childSafetyLock", e, 'Child safety lock', 'safety')}
                    >
                        Child safety lock
                    </Checkbox>
                    </div>
                </Col>
                <Col span={8}>
                    <div className="form-fields">
                    <Checkbox
                        valuePropName="checked"
                        checked={equipments?.curtainAirbags?.value}
                        onChange={(e) => onCheckboxChange("curtainAirbags", e, 'Curtain Airbags', 'safety')}
                    >
                        Curtain Airbags
                    </Checkbox>
                    </div>
                </Col>
                <Col span={8}>
                    <div className="form-fields">
                    <Checkbox
                        valuePropName="checked"
                        checked={equipments?.frontAirbags?.value}
                        onChange={(e) => onCheckboxChange("frontAirbags", e, 'Front Airbags', 'safety')}
                    >
                        Front Airbags
                    </Checkbox>
                    </div>
                </Col>
                <Col span={8}>
                    <div className="form-fields">
                    <Checkbox
                        valuePropName="checked"
                        checked={equipments?.immobilizer?.value}
                        onChange={(e) => onCheckboxChange("immobilizer", e, 'Immobilizer', 'safety')}
                    >
                        Immobilizer
                    </Checkbox>
                    </div>
                </Col>
                <Col span={8}>
                    <div className="form-fields">
                    <Checkbox
                        valuePropName="checked"
                        checked={equipments?.iosfix?.value}
                        onChange={(e) => onCheckboxChange("iosfix", e, 'ISOFIX', 'safety')}
                    >
                        ISOFIX
                    </Checkbox>
                    </div>
                </Col>
                <Col span={8}>
                    <div className="form-fields">
                    <Checkbox
                        valuePropName="checked"
                        checked={equipments?.seatBelts?.value}
                        onChange={(e) => onCheckboxChange("seatBelts", e, 'Seat belts', 'safety')}
                    >
                        Seat belts
                    </Checkbox>
                    </div>
                </Col>
                <Col span={8}>
                    <div className="form-fields">
                    <Checkbox
                        valuePropName="checked"
                        checked={equipments?.sideAirbags?.value}
                        onChange={(e) => onCheckboxChange("sideAirbags", e, 'Side Airbags', 'safety')}
                    >
                        Side Airbags
                    </Checkbox>
                    </div>
                </Col>
                <Col span={8}>
                    <div className="form-fields">
                    <Checkbox
                        valuePropName="checked"
                        checked={equipments?.stabilityControl?.value}
                        onChange={(e) => onCheckboxChange("stabilityControl", e, 'Stability control', 'safety')}
                    >
                        Stability control
                    </Checkbox>
                    </div>
                </Col>
            </Row>
            <Row>
                <Col span={24}>
                    <div className="form-fields">
                    <p className="form-field-label">Other Safety</p>
                    <Input.TextArea
                        rows={3}
                        value={equipments?.safetyOther?.value}
                        onChange={(e) => handleFieldChange("safetyOther", e, 'Other Safety', 'safety')}
                    />
                    </div>
                </Col>
            </Row>

            <Divider />
            
        </div>
    );
}

export default Equipments;